import * as React from 'react';
import { InfoBarShowDetailsAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfobarShowHideDetailsPart, InfobarShowHideDetailsPartProps } from 'owa-info-bar-view';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import getInfoBarLinkColorStyle from 'owa-info-bar/lib/utils/getInfoBarLinkColorStyle';
import {
    MailTipsActionType,
    MailTipsType,
    MailTipsCategory,
    roundOffCount,
    MailtipsActionDatapointName,
} from '../datapoints';
import { logUsage } from 'owa-analytics-actions';

const styles = require('./MultiRecipientMailtip.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MultiRecipientMailtipProps {
    colorScheme?: ColorScheme;
    messageInfoElement: JSX.Element;
    removeAllActionElement?: JSX.Element;
    showHideDetails?: InfoBarShowDetailsAction;
    detailsRenderer: () => JSX.Element;
    mailTipsCategory?: MailTipsCategory;
    recipientCount?: number;
}

export interface MultiRecipientMailtipState {
    isDetailShown: boolean;
}

export default class MultiRecipientMailtip extends React.Component<
    MultiRecipientMailtipProps,
    MultiRecipientMailtipState
> {
    constructor(props: MultiRecipientMailtipProps) {
        super(props);
        this.state = {
            isDetailShown: false,
        };
    }

    toggleIsDetailShown = () => {
        const { mailTipsCategory, recipientCount } = this.props;
        this.setState({
            isDetailShown: !this.state.isDetailShown,
        });
        // Log datapoint
        const actionType = !this.state.isDetailShown
            ? MailTipsActionType.HideDetails
            : MailTipsActionType.ShowDetails;
        logUsage(MailtipsActionDatapointName, [
            actionType,
            mailTipsCategory,
            MailTipsType.MultipleRecipients,
            roundOffCount(recipientCount),
        ]);
    };

    private getShowHideDetailsActionText = (): JSX.Element => {
        if (!this.props.showHideDetails) {
            return null;
        }

        const infobarShowHideDetailsPartProps: InfobarShowHideDetailsPartProps = {
            ...this.props.showHideDetails,
            isShowingDetails: this.state.isDetailShown,
            clickHandler: this.toggleIsDetailShown,
            className: classNames(styles.link, getInfoBarLinkColorStyle(this.props.colorScheme)),
        };

        return <InfobarShowHideDetailsPart {...infobarShowHideDetailsPartProps} />;
    };

    render() {
        const shouldAddSpaceAfterMessageInfoElement =
            this.props.removeAllActionElement || this.props.showHideDetails;

        return (
            <>
                <span
                    className={classNames({
                        blankSpaceAfter: shouldAddSpaceAfterMessageInfoElement,
                    })}>
                    {this.props.messageInfoElement}
                </span>
                {this.getShowHideDetailsActionText()}
                {this.props.removeAllActionElement && this.props.showHideDetails ? (
                    <span> | </span>
                ) : null}
                {this.props.removeAllActionElement}
                {this.state.isDetailShown && this.props.detailsRenderer()}
            </>
        );
    }
}
